 //export const SERVER_URL = "http://localhost:3005"
export const SERVER_URL = "https://crypwallet.com"
